// The BUMA icon from the logo redesign: rounded hexagon (point on top) with the owl "m" and two dot eyes.
// `main` fills the hexagon, `accent` colours the eyes — the official pairs are in MARK_COLOURS.
export const MARK_COLOURS = {
  blue: ["#0248E2", "#FC7B12"], purple: ["#5B2BD6", "#FF8A1F"], orange: ["#E8590C", "#0B1B4D"], green: ["#0A9B5F", "#0B1B4D"],
  red: ["#DC2F3C", "#0B1B4D"], teal: ["#0B8A8F", "#FF6B4A"], pink: ["#D6336C", "#0B1B4D"], midnight: ["#0B1B4D", "#FC7B12"],
};
const HEX = "M60.9 9.0 Q80.0 -2.0 99.1 9.0 L132.0 28.0 Q151.0 39.0 151.0 61.0 L151.0 99.0 Q151.0 121.0 132.0 132.0 L99.1 151.0 Q80.0 162.0 60.9 151.0 L28.0 132.0 Q9.0 121.0 9.0 99.0 L9.0 61.0 Q9.0 39.0 28.0 28.0 Z";

// sticker: a white edge round the hexagon + soft shadow, as on the brand sticker sheet
export function BumaMark({ colour = "blue", size = 48, sticker = false, className = "", style, title }) {
  const [main, accent] = MARK_COLOURS[colour] || MARK_COLOURS.blue;
  return (
    <svg viewBox={sticker ? "-10 -10 180 180" : "0 0 160 160"} width={size} height={size} className={className} style={sticker ? { filter: "drop-shadow(0 6px 10px rgba(11,27,77,.18))", ...style } : style} {...(title ? { role: "img", "aria-label": title } : { "aria-hidden": true })}>
      {sticker && <path d={HEX} fill="#FFFFFF" stroke="#FFFFFF" strokeWidth="18" strokeLinejoin="round" />}
      <path d={HEX} fill={main} />
      <g transform="translate(79 81) rotate(18) scale(0.41)">
        <path d="M-90 80 V-35 A45 45 0 0 1 0 -35 V10 M0 -35 A45 45 0 0 1 90 -35 V80" fill="none" stroke="#FFFFFF" strokeWidth="30" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M-58.5 -85.2 L-108.6 -98.6 L-95.2 -48.5 Z M58.5 -85.2 L108.6 -98.6 L95.2 -48.5 Z" fill="#FFFFFF" stroke="#FFFFFF" strokeWidth="8" strokeLinejoin="round" />
        <circle cx="-45" cy="2" r="16" fill={accent} />
        <circle cx="45" cy="2" r="16" fill={accent} />
      </g>
    </svg>
  );
}

// The small outline hexagons and the pairs of orange "eyes" from the sticker sheet: light decoration around brand art.
export const HexOutline = ({ size = 28, className = "", style }) => (
  <svg viewBox="-6 -6 172 172" width={size} height={size} className={className} style={style} aria-hidden="true"><path d={HEX} fill="none" stroke="#B9C8F2" strokeWidth="12" /></svg>
);
export const EyeDots = ({ size = 10, colour = "#FC7B12", className = "", style }) => (
  <span className={`inline-flex ${className}`} style={{ gap: size * 0.45, ...style }} aria-hidden="true">
    <span className="rounded-full" style={{ width: size, height: size, background: colour }} /><span className="rounded-full" style={{ width: size, height: size, background: colour }} />
  </span>
);
